import { IIssue } from './issue';

/** Volatile, read-only projection. Never merge this payload into the operational Issue store. */
export const LINKED_ISSUE_OVERVIEW_ENTITY = 'issueOverview';
export type ILinkedIssueOverview = Pick<IIssue,
  'id' | 'projectId' | 'title' | 'protocolNumber' | 'typeId' | 'stateId' |
  'suspension' | 'archivedAt' | 'createdAt' | 'updatedAt' | 'version'>;

/** Unavailable deliberately reveals no project, title or other ticket metadata. */
export type LinkedIssueOverviewUpdate =
  | (ILinkedIssueOverview & { available: true })
  | { id: string; available: false };
